import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
const AppContent = ({ children, diffLayout }) => (
  <Grid.Row className={`AppContent ${diffLayout ? "diffContent" : ""}`}>
    <Grid.Column>{children}</Grid.Column>
  </Grid.Row>
)
export default AppContent
